function toggleSwatchArrows(swiper) {

  const wrapper = swiper.el.closest('.product__color-swatches');

  if (!wrapper) return;

  const nextButton = wrapper.querySelector('.color-swatches-next');
  const prevButton = wrapper.querySelector('.color-swatches-prev');

  if (!nextButton || !prevButton) return;

  if (swiper.isEnd) {
    nextButton.classList.remove('is-visible');
  } else {
    nextButton.classList.add('is-visible');
  }

  if (swiper.isBeginning) {
    prevButton.classList.remove('is-visible');
  } else {
    prevButton.classList.add('is-visible');
  }

}

function initColorSwatchesCarousel() {

  document.querySelectorAll('.color-swatches-swiper').forEach((carousel) => {

    if (carousel.swiper) return;

    const wrapper = carousel.closest('.product__color-swatches');

    if (!wrapper) return;

    const nextButton = wrapper.querySelector('.color-swatches-next');
    const prevButton = wrapper.querySelector('.color-swatches-prev');

    if (!nextButton || !prevButton) return;

    const swiper = new Swiper(carousel, {

      slidesPerView: 'auto',

      spaceBetween: 12,

      watchOverflow: true,

      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      on: {

        init: function () {
          toggleSwatchArrows(this);
        },

        slideChange: function () {
          toggleSwatchArrows(this);
        },

        resize: function () {
          toggleSwatchArrows(this);
        },

        update: function () {
          toggleSwatchArrows(this);
        }
      }
    });
  });

}

document.addEventListener(
  'DOMContentLoaded',
  initColorSwatchesCarousel
);

document.addEventListener(
  'shopify:section:load',
  initColorSwatchesCarousel
);